import './index.css';

export default {
  props: {
    placement: { type: String, default: () => 'bottom' },
    title: { type: String, default: () => '提示' },
    width: { type: String, default: () => '200' },
    trigger: { type: String, default: () => 'click' },
    content: { type: String, default: () => '' },
    cancelText: { type: String, default: () => '取消' },
    submitText: { type: String, default: () => '确定' },
    finishText: { type: String, default: () => '确定' },
    buttonText: { type: String, default: () => 'click 激活' },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    submit() {
      this.visible = false;
    },
    finish() {
      this.visible = false;
    },
  },
  render() {
    const { finish, submit, cancel } = this.$listeners;
    const { ...attrs } = this.$attrs;
    return this.$slots.default && (
      <el-popover
        class="a-popover"
        placement={this.placement}
        title={this.title}
        width={this.width}
        v-model={this.visible}
        trigger={this.trigger}
        content={this.content}
        {...{ attrs }}
      >
        {this.$slots.default}
        {(finish || submit || cancel) && (
          <div class="action">
            {cancel && <el-button type="text" size="mini" on-click={this.cancel}>{this.cancelText}</el-button>}
            {submit && <el-button type="primary" size="mini" on-click={this.submit}>{this.submitText}</el-button>}
            {finish && <el-button type="success" size="mini" on-click={this.finish}>{this.finishText}</el-button>}
          </div>
        )}
        <el-button slot="reference">{this.buttonText}</el-button>
      </el-popover>
    );
  }
}